<template>
  <el-date-picker style="width: 240px" :value="value" type="daterange" value-format="yyyy-MM-dd"
    placeholder="选择时间" start-placeholder="开始时间" end-placeholder="结束时间" :clearable="false"
    :picker-options="{ disabledDate, onPick }" @input="handleInput">
  </el-date-picker>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: {
    value: Array,
  },
  data() {
    return {
      pickDate: null,
    }
  },
  methods: {
    disabledDate(date) {
      const curDate = new Date(date);
      const pickDate = new Date(this.pickDate);
      return this.pickDate && (curDate.getMonth() !== pickDate.getMonth() || curDate.getFullYear() !== pickDate.getFullYear());
    },
    onPick({ maxDate, minDate }) {
      if ((!!maxDate && !minDate) || (!maxDate && !!minDate)) {
        this.pickDate = maxDate || minDate;
      } else {
        this.pickDate = null;
      }
    },
    handleInput(value) {
      this.$emit("input", value);
    },
  },
}
</script>

<style lang="scss">

</style>